export default "__VITE_ASSET__VcF7ZnPW__"